"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiInput = {
    styleOverrides: {
        underline: {
            '&:after': {
                borderBottomColor: colors_1.default.violet,
            },
        },
        input: {
            '&::placeholder': {
                opacity: 1,
                color: 'rgba(0, 0, 0, 0.6)',
            },
        },
    },
};
exports.default = muiInput;
//# sourceMappingURL=muiInput.js.map